import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './common/guards/auth.guard';
import { AdminGuard } from './common/guards/admin.guard';
import { HomeComponent } from './layout/components/private/home/home.component';
import { HomePublicComponent } from './layout/components/public/home-public/home-public.component';
import { CataloguePageComponent } from './main/category/catalogue/catalogue-page.component';
import { ResultPageComponent } from './main/result/result-page/result-page.component';
import { ViewDetailComponent } from './main/application/view-detail.component';
import { CategoryComponent } from './main/category/category.component';
import { MulticompanyPageComponent } from './main/multicompany-page/multicompany-page.component';
import { multicompanyGuard } from './common/guards/multicompany.guard';

const appRoutes: Routes = [
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'public/:id', component: HomePublicComponent },
  {
    path: 'admin',
    loadChildren: () => import('./main/admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AdminGuard]
  },
  {
    path: 'multicompany',
    component: MulticompanyPageComponent,
    canActivate: [multicompanyGuard]
  },
  {
    path: 'catalogue',
    component: CataloguePageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'category-detail/:id',
    component: CategoryComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'application-detail/:id',
    component: ViewDetailComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'results',
    component: ResultPageComponent,
    canActivate: [AuthGuard]
  },
  { path: '', redirectTo: 'home', pathMatch: 'full' }
  // { path: '**', redirectTo: 'home', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
export { appRoutes };
